<template>
  <section
    id="about-techAcademy-anniversary-top"
    class="co-bg-striped"
  >
    <div class="co-container-lg mx-auto px-4 py-20">
      <h2 class="co-heading-2-caption">
        テックアカデミーとは？
      </h2>
      <h3 class="co-display-10 mb-9 text-left leading-base text-co-gray-500 md:text-center">
        <span class="inline md:block">現役エンジニアから学べるオンラインに特化したプログラミングスクール。</span>
        <span class="inline md:block">講師は全員、通過率10％の選考に合格した現役エンジニア。</span>
        <span class="inline md:block">確かなスキルをもとに受講生をマンツーマンサポートします。</span>
      </h3>
      <div class="flex flex-col gap-4 md:flex-row md:gap-8">
        <div class="w-full md:w-1/3">
          <div class="flex h-full flex-col items-center justify-between rounded border border-co-primary-400 bg-white px-5 py-6 text-center">
            <h3 class="co-display-10 mb-4 font-bold">
              『日本e-Learning大賞』受賞
            </h3>
            <img
              src="~/assets/images/Te/TeCounseling/AboutTechAcademyAnniversary/badge-e-learning-awards.png"
              alt="『日本e-Learning大賞』受賞"
              width="156"
              height="119"
              loading="lazy"
            >
            <div class="mt-3">
              第13回 日本e-Learning大賞
              <br>
              「プログラミング教育特別部門賞」
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/3">
          <div class="flex h-full flex-col items-center justify-between rounded border border-co-primary-400 bg-white px-5 py-6 text-center">
            <h3 class="co-display-10 mb-4 font-bold">
              10年以上続く老舗スクール
            </h3>
            <img
              src="~/assets/images/Te/TeCounseling/AboutTechAcademyAnniversary/badge-10thanniversary.svg"
              width="120"
              height="120"
              loading="lazy"
            >
            <div class="mt-3">
              900社、10万人を超える
              <br>
              教育実績
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/3">
          <div class="flex h-full flex-col items-center justify-between rounded border border-co-primary-400 bg-white px-5 py-6 text-center">
            <h3 class="co-display-10 mb-4 font-bold">
              博報堂のグループ会社が運営
            </h3>
            <img
              class=""
              src="~/assets/images/Te/TeCounseling/AboutTechAcademyAnniversary/logo-hdy.png"
              alt="博報堂のグループ会社が運営"
              width="301"
              height="53"
              loading="lazy"
            >
            <div class="mt-3">
              世界トップ12、国内トップ2を誇る
              <br>
              広告代理企業のグループ
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
